import { Stack, HStack, Box } from '@chakra-ui/react';
import { Dialog } from '@halo/ui-react';
import type { ReactNode } from 'react';

export interface BodyProps {
  children: ReactNode;
  selectedList: ReactNode;
}

const Body = ({ children, selectedList }: BodyProps) => {
  return (
    <Dialog.Body>
      <Stack gap="6" css={{ '--field-label-width': '140px' }}>
        <HStack
          flex="1"
          minW="0"
          border="1px solid"
          borderColor="border"
          borderRadius="lg"
          alignItems="stretch"
          gap="3"
        >
          <Box
            className="Users"
            flex="1"
            minW="0"
            p="3"
            borderRight="1px solid"
            borderColor="border"
          >
            {children}
          </Box>
          {selectedList}
        </HStack>
      </Stack>
    </Dialog.Body>
  );
};

export { Body };
